import { keyframes } from "@emotion/react"
import styled from "@emotion/styled"

export const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

export const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`

export const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`

// Styled components
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 2rem;
  text-align: center;
`

export const StatusCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 3rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
  animation: ${fadeIn} 0.6s ease-out;
`

export const StatusIcon = styled.div<{ status: string }>`
  width: 100px;
  height: 100px;
  margin: 0 auto 2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ status }) =>
    status === 'success'
      ? '#4caf50'
      : status === 'error'
        ? '#f44336'
        : '#2196f3'};
  color: white;
  font-size: 2.5rem;
  animation: ${({ status }) =>
    status === 'pending'
      ? `${spin} 1s linear infinite`
      : `${pulse} 0.6s ease-out 2`};
`

export const StatusTitle = styled.h2`
  font-size: 1.8rem;
  margin-bottom: 1rem;
  color: #333;
`

export const StatusMessage = styled.p`
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 2rem;
`

export const Button = styled.button`
  background: #2196f3;
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #0d8bf2;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(33, 150, 243, 0.3);
  }
`